import useCards from '@/hooks/useCards';
import { Container, Grid, Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import ReadingItem from '@/components/reading/ReadingItem';

export default function ReadingList() {
  const { readings, getReadings } = useCards();
  const navigate = useNavigate();

  // Fetch readings when component mounts
  useEffect(() => {
    getReadings();
  }, [getReadings]);

  let readingsArray = Array.isArray(readings) ? readings : [];
  readingsArray = readingsArray.map((reading) => {
    return {
      ...reading,
      interpretation: typeof reading.interpretation === 'string'
        ? JSON.parse(reading.interpretation)
        : reading.interpretation
    }
  });

  return (
    <Container sx={{ overflow: 'auto', padding: 0, paddingTop: 2 }}>
      {readingsArray.length === 0 ? (
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="h6" sx={{ mb: 3 }}>
            No readings available yet
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate('/mode-selector')}
            sx={{
              background: (theme) => theme.palette.secondary.main,
              borderRadius: '20px',
              boxShadow: (theme) => `0 3px 5px 2px ${theme.palette.secondary.light}33`,
              color: '#ffffff',
              padding: '10px 30px',
              '&:hover': {
                background: (theme) => theme.palette.secondary.dark,
                transform: 'scale(1.05)',
                transition: 'all 0.2s ease-in-out'
              }
            }}
          >
            Get Your First Reading
          </Button>
        </Box>
      ) : (
        <div>
          <Grid container spacing={2}>
            {readingsArray.map((reading, id) => (
              <ReadingItem
                key={id}
                reading={reading}
                index={id}
                createdAt={reading.createdAt}
                totalReadings={readingsArray.length}
              />
            ))}
          </Grid>
        </div>
      )}
    </Container>
  );
}
